import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Overlay from '../components/Overlay';
import React, {useState, useEffect} from "react";
import Swal from 'sweetalert2';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/config";
import Helmet from "react-helmet";

const Contact = () => {

  const [fullname, setfullname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");
  const [message, setmessage] = useState("");
  const [showloding, setshowloding] = useState(false);

  const handleformsubmit = async() => {
    if (!fullname || !email || !number) {
      alert('Please enter all mandatory fields.');
      return;
    }

    setshowloding(true);
    try {
      var data = {
        fullname: fullname,
        email: email,
        number: number,
        message: message
      }
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.post(apiUrl + "contactformsubmit", data, headers);

      if(res?.data?.status == 'success') {
        Swal.fire({
          title: 'Submitted Successfully!',
          text: "One of our representative will get back to you",
          icon: 'success',
          customClass: {
            icon: 'custom-swal-icon'
          },
          width: '400px',
          confirmButtonText: 'Ok'
        });
        setfullname("");
        setemail("");
        setnumber("");
        setmessage("");
      } else {
        Swal.fire({
          text: res.data.message,
          icon: 'error',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '400px',
          confirmButtonText: 'Ok'
        });
      }
      console.log('data >>', data);
    } catch (err) {
      alert(err.message);
    } finally {
      setshowloding(false);
    }
  }
  return (
    <>
    <Helmet>
        {/* 🌟 Meta Tags for SEO */}
        <title>Contact Blisstainment | Vinyl Records Support India</title>
        <meta name="description" content="Contact Blisstainment for vinyl record orders, pre-book support, product availability and business enquiries. Registered office: Thane, Maharashtra." />
        <meta name="author" content="Blisstainment" />

       
        {/* ✅ Primary Keyword */}
        <meta name="keywords" content="Blisstainment contact" />

        {/* ✅ Canonical Tag */}
        <link rel="canonical" href="https://www.blisstainment.com/contact-us" />

        {/* ✅ Open Graph (OG) Tags - For Social Media */}
        {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}


        
      </Helmet>

      <section className="pt-5 pb-5">
        <div className="container">
          <h2 className="text-center weight600 mt20">Get In Touch With us</h2>

          <div className="row contactmainform mt-5">
          <div className="col-md-3"></div>
            <div className="col-md-6">
                <Form.Group className="mb-3" controlId="FormName">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control type="text" placeholder="Enter Full Name" value={fullname} onChange={(t) => {setfullname(t.target.value)}} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="FormEmail">
                  <Form.Label>Email Id *</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email Address"
                    value={email} onChange={(t) => {setemail(t.target.value)}}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="Formphone">
                  <Form.Label>Phone No *</Form.Label>
                  <Form.Control type="text" placeholder="Enter Your Number" value={number} onChange={(t) => {setnumber(t.target.value)}} />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="1"
                >
                  <Form.Label>Message</Form.Label>
                  <Form.Control as="textarea" rows={3} placeholder="Enter Message" value={message} onChange={(t) => {setmessage(t.target.value)}} />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="contactbtn"
                  onClick={handleformsubmit}
                  disabled={showloding}
                >
                  {showloding && (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  )}
                  {showloding ? '' : 'Submit'}
                </Button>
            </div>
            <div className="col-md-3"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
